import React from 'react';
import styles from './AccountCell.module.css';
import cn from 'classnames';
import TruncatedTextCell from '../TruncatedTextCell/TruncatedTextCell';

type AccountCellProps = {
    accountName: string;
    accountUsername: string;
    accountUrl: string;
    containerClassName?: string;
    accountNameClassName?: string;
    usernameClassName?: string;
};

const AccountCell = ({
    accountName,
    accountUsername,
    accountUrl,
    containerClassName,
    accountNameClassName,
    usernameClassName,
}: AccountCellProps) => (
    <div className={cn(styles.container, containerClassName)}>
        <TruncatedTextCell className={cn(styles.accountName, accountNameClassName)}>{accountName}</TruncatedTextCell>
        <a
            onClick={(e) => e.stopPropagation()}
            className={cn(styles.username, usernameClassName)}
            href={accountUrl}
            target="_blank"
            rel="noopener noreferrer"
        >
            @{accountUsername}
        </a>
    </div>
);

export default AccountCell;
